import { postDataAgnostic } from '../Services/dataApi';
import { formatBearerToken } from '../Common.functions';

const userFirstedLoggedIn = (userObject, token) => {
  postDataAgnostic('credentials/login', null, userObject, formatBearerToken(token))
    .then((res) => {})
    .catch((err) => {});
};

export { userFirstedLoggedIn };
